<template>
  <div>
    <form id="form" @submit.prevent="">
      <div class="form-group">
        <label>دما</label>

        <input type="number" class="form-control" v-model.lazy="form.status" />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "TEP",
  data() {
    return {
      changed: false,
      form: {}
    };
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  computed: {
    ...mapGetters(["device"]),
    originalForm() {
      return {
        id: this.device.id,
        name: this.device.name,
        status: this.device.status.toString()
      };
    }
  },
  watch: {
    form: {
      handler() {
        // if (_.isEqual(this.form, this.originalForm) === false) {
        this.$emit("change-form", this.form.status);
        // }
      },
      deep: true
    }
  }
};
</script>
